type SaveChunkParams = {
  partNumber: number;
  blob: Blob;
  audioFormat: "webm" | "m4a";
  mimeType: string;
};

const LOCAL_EXPORT_HOSTS = new Set(["localhost", "127.0.0.1"]);
const LOCAL_EXPORT_ENDPOINT = "http://localhost:5055/save-chunk";
const EXPORT_ENV_FLAG = "EXPO_PUBLIC_ENABLE_CHUNK_EXPORT";

const isLocalChunkExportEnabled = (): boolean => {
  if (typeof window === "undefined") return false;
  if (process.env.NODE_ENV === "production") return false;
  if (process.env[EXPORT_ENV_FLAG] !== "true") return false;
  return LOCAL_EXPORT_HOSTS.has(window.location.hostname);
};

const formatPartName = (partNumber: number, extension: string): string => {
  const padded = String(partNumber).padStart(6, "0");
  return `part-${padded}.${extension}`;
};

export const saveChunkToDisk = async ({
  partNumber,
  blob,
  audioFormat,
  mimeType,
}: SaveChunkParams): Promise<void> => {
  if (!isLocalChunkExportEnabled()) return;
  if (!blob || blob.size === 0) return;

  const extension = audioFormat === "m4a" ? "m4a" : "webm";
  const name = formatPartName(partNumber, extension);
  const url = `${LOCAL_EXPORT_ENDPOINT}?name=${encodeURIComponent(name)}`;

  try {
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": mimeType || blob.type || "application/octet-stream",
      },
      body: blob,
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[ChunkExport] Failed to save chunk locally", error);
    }
  }
};
